import React from 'react';

type Props = {
  className?: string;
};

// eslint-disable-next-line import/prefer-default-export
export const LoaderArrows = ({ className }: Props): JSX.Element => (
  <svg width={86} height={86} xmlns="http://www.w3.org/2000/svg" className={className}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h86v86H0z" />
      <path
        d="m67.388 34.85 7.373 4.12c.375.21.848.028.986-.378l2.724-7.995a.688.688 0 0 0-.897-.864l-3.555 1.364C67.446 13.966 48.23 5.407 31.097 11.98 19.871 16.287 12.33 26.023 10.31 37.038c-.16.869.46 1.675 1.336 1.792.875.117 1.676-.499 1.84-1.367 1.867-9.9 8.669-18.624 18.759-22.496 15.481-5.94 32.847 1.795 38.788 17.277l-3.554 1.364a.688.688 0 0 0-.09 1.242zM11.84 54.956l-3.415 1.31a.688.688 0 0 1-.897-.864l2.724-7.995a.688.688 0 0 1 .986-.378l7.373 4.12a.687.687 0 0 1-.09 1.243l-3.413 1.31c5.91 15.404 23.19 23.1 38.594 17.19C63.69 67.06 70.438 58.45 72.338 48.664c.184-.949 1.06-1.623 2.017-1.495.958.129 1.635 1.01 1.457 1.96-2.067 11.007-9.627 20.722-20.856 25.03-17.21 6.604-36.513-1.994-43.116-19.203z"
        fill="currentColor"
      />
    </g>
  </svg>
);
